import { Component, OnInit, inject } from '@angular/core';
import { CommonModule, Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { FirebaseTableService } from '../../services/firebase-table.service';
import { SharedTableComponent } from '@tamilarasitech/shared-ui-components';

@Component({
  selector: 'app-corporatemembers',
  standalone: true,
  imports: [CommonModule, SharedTableComponent],
  templateUrl: './corporatemembers.component.html',
  styleUrls: ['./corporatemembers.scss']
})
export class CorporateMembersComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private firebaseService = inject(FirebaseTableService);
  private location = inject(Location);
  private router = inject(Router);

  corporateData: any = null;
  memberStats = { total: 0, active: 0, inactive: 0, suspended: 0 };
  loading = true;
  error: string | null = null;
  corporateId: string = '';

  ngOnInit() {
    this.corporateId = this.route.snapshot.params['id'];
    if (this.corporateId) {
      this.loadCorporateData();
      this.loadMemberStats();
    } else {
      this.error = 'No corporate ID provided';
      this.loading = false;
    }
  }
goBack(): void {
    this.router.navigate(['/corporates']);
  }
  async loadCorporateData() {
    this.loading = true;
    this.error = null;
    
    try {
      // ✅ Using service method instead of direct Firebase calls
      const corporatePath = `data/digitvcards/corporates`;
      
      // Use the service method for proper injection context
      const corporateDoc = await this.firebaseService.getDoc(corporatePath, this.corporateId);
      
      if (corporateDoc) {
        this.corporateData = corporateDoc;
      } else {
        this.error = 'Corporate not found';
      }
    } catch (error) {
      console.error('Error loading corporate data:', error);
      this.error = 'Failed to load corporate details';
    } finally {
      this.loading = false;
    }
  }

  async loadMemberStats() {
    try {
      // Query memberships collection based on orgId
      const queryConfig = {
        field: 'orgId',
        op: '==',
        param: this.corporateId
      };
      const memberships = await this.firebaseService.getPaginatedData(
        'data/digitvcards/memberships', 
        100, // Limit to 100 members for stats
        undefined, 
        queryConfig
      );

      this.memberStats = {
        total: memberships.data.length,
        active: memberships.data.filter((m: any) => m.status === 'active').length,
        inactive: memberships.data.filter((m: any) => m.status === 'inactive').length,
        suspended: memberships.data.filter((m: any) => m.status === 'suspended').length
      };
    } catch (error) {
      console.error('Error loading member stats:', error);
      this.memberStats = { total: 0, active: 0, inactive: 0, suspended: 0 };
    }
  }

  getCompanyTypeLabel(type: string): string {
    const types: { [key: string]: string } = {
      'private': 'Private Limited',
      'public': 'Public Limited', 
      'sole': 'Sole Proprietorship',
      'llp': 'Limited Liability Partnership'
    };
    return types[type] || type;
  }

  viewCorporateProfile() {
    // Navigate to corporate profile view
    console.log('View corporate profile:', this.corporateId);
  }

  editCorporateProfile() {
    // Navigate to corporate edit page
    console.log('Edit corporate profile:', this.corporateId);
  }
}